import styled from "styled-components";
import CompetencyModal from "../../components/CompetencyModal";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import MinimalSelect from "../../components/MinimalSelect";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import theme from "../../styles/theme";
import { Icon as MuiIcon } from "@mui/material";
import { useState } from "react";

const Header = styled.h4`
  //   font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  //   line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
  align-item: center;
  gap: 2;
`;

const InfoBox = styled.div`
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #1e40af;
  font-size: 15px;
  line-height: 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

interface Props {
  setOpen: (x: boolean) => void;
  isOpen: boolean;
  competencyData: {
    competency_code: any;
    curriculum_version: any;
  },
  legacyVersionsData: Array<{ display_version: string; version_number: number }>;
//   versionOption: Array<{ label: string; value: number }>;
  saveClone: (competency_code: string, source_version: number, target_versions: number[]) => void;
}
export const LegacyConfirmModal = (props: Props) => {
  const { setOpen, isOpen, competencyData, legacyVersionsData, saveClone } = props;
  const [selectedVersion, setSelectedVersion] = useState({
    label: "",
    value: 0,
  });

  return (
    <Modal
      customStyle={{
        content: {
          maxWidth: "600px",
          color: "black",
          padding: 20,
        },
      }}
      isOpen={isOpen}
      setOpen={setOpen}
    >
      <FlexBox>
        <FlexGrow>
          <Header>
            <MuiIcon
              sx={{
                color: "blue",
                marginRight: "10px",
                // textShadow: "0 2px 4px #8080807a",
              }}
            >
              file_copy
            </MuiIcon>
            Clone Competency
          </Header>
        </FlexGrow>
        <ClickableIcon
          color="black"
          name="close"
          onClick={() => setOpen(false)}
        />
      </FlexBox>

      {
       
      <FlexBox>
        <InfoBox>
          <MuiIcon
            sx={{
              color: "#2563eb",
              fontSize: "20px",
              flexShrink: 0,
              marginTop: "2px"
            }}
          >
            info
          </MuiIcon>
          <span>Competency {competencyData?.competency_code} also exists in Active Legacy version(s) ({legacyVersionsData?.map((v) => v?.display_version).join(", ")}). Do you want to copy this competency's content to the Active Legacy version(s)?</span>
        </InfoBox>
        
        
        <FlexBox justify="end" style={{ width: "100%", marginTop: 20 }}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            status={Status.button}
            style={{
              border: "2px solid #cbd5e1",
              background: "white",
              color: "#334155"
            }}
          >
            Cancel
          </Button>
          <Button
            // disabled={!selectedVersion.label}
            onClick={() => saveClone(competencyData?.competency_code, competencyData.curriculum_version, legacyVersionsData.map(v => v.version_number))}
            style={{
              //   width: 110,
              whiteSpace: "nowrap",
              background: theme.color.blueButton,
              color: "white",
              boxShadow: "0 2px 5px #808080cc",
              border: "none",
            }}
            status={Status.button}
          >
            Clone Competency
          </Button>
        </FlexBox>
      </FlexBox>}
    </Modal>
  );
};
